import React from "react";

type RedirectMapType = {
    userAuthorities: Array<string>;
};

function getDefaultRedirectMap(): RedirectMapType {
    return {
        userAuthorities: [],
    };
}

export const RedirectMapContext = React.createContext<RedirectMapType>(getDefaultRedirectMap());

export const useRedirectMapContext = () => React.useContext(RedirectMapContext);

type PropsType = {
    userAuthorities: Array<string>;
    children: any;
};

export const RedirectMapContextProvider = (props: PropsType) => {
    const redirectMapContextValues = React.useMemo(
        () => ({
            userAuthorities: props.userAuthorities,
        }),
        [props.userAuthorities]
    );

    return (
        <RedirectMapContext.Provider value={redirectMapContextValues}>
            {props.children}
        </RedirectMapContext.Provider>
    );
};
